export default __webpack_public_path__ + "static/media/icon-node-current.8f10ac63.svg";